// extracted by mini-css-extract-plugin
module.exports = {"container":"_2wTCTfphYnnnWsdHS4Aw-l","icon":"_3eZ7SkDhue7ktDm9km7S4g"};